// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"0d4655c0","56":"0504a822","323":"0504a822","349":"0504a822","440":"0504a822","451":"0504a822","824":"0504a822","922":"0504a822"}[chunkId] + ".chunk.css";
};